import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Home = () => {

    const [images, setImages] = useState([]);

    useEffect(() => {
        fetch(`${process.env.PUBLIC_URL}/images.json`)
            .then((response) => response.json())
            .then((data) => setImages(data));
    }, []);

    return (
        <div className="container text-center mt-5">
        {/* Banner Section */}
        <div className="banner">
            <img 
                src={`${process.env.PUBLIC_URL}/images/solring.png`} 
                alt="Banner" 
                className="img-fluid w-100"
            />
        </div>

        {/* Menu Bar */}
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
                <div className="container">
                    <Link className="navbar-brand" to="/">The Sol Ring</Link>
                    <div className="collapse navbar-collapse">
                        <ul className="navbar-nav ml-auto">
                            <li className="nav-item">
                                <Link className="nav-link" to="/">Home</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/gallery">Gallery</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

        

        <div className="container text-center mt-5">
            {/* Running Line of Images */}
            <div className="image-slider">
                <div className="slider-track">
                    {images.map((src, index) => (
                        <img key={index} src={process.env.PUBLIC_URL + src} alt={`Slide ${index}`} />
                    ))}
                    {images.map((src, index) => (
                        <img key={`duplicate-${index}`} src={process.env.PUBLIC_URL + src} alt={`Duplicate Slide ${index}`} />
                    ))}
                </div>
            </div>
        </div>

        <div className="container text-center mt-5">
            <h1 className="display-4">Welcome to the Home Page</h1>
            <p className="lead">This is a sample website built with React and styled with Bootstrap.</p>
            <button className="btn btn-primary">Learn More</button>
        </div>
        </div>
    );
};

export default Home;